<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="short_name" slot-scope="props")
            optional-cell-value(v-model="props.row.short_name")

        template(slot="mode" slot-scope="props")
            span(v-if="props.row.mode == null")
                i.text-muted Not set

            span(v-if="props.row.mode === 0")
                | Subtotal

            span(v-if="props.row.mode === 1")
                | Per product

        template(slot="inclusive" slot-scope="props")
            span(v-if="props.row.inclusive == null")
                i.text-muted Not set

            span(v-if="props.row.inclusive === true")
                | Included in price

            span(v-if="props.row.inclusive === false")
                | Added to price

    tax-form(ref="taxForm")
</template>

<script>
import Auth from '@js/plugins/auth';
import taxForm from './tax_form.vue';
import CollectionCounter from '@js/components/collection-counter';
import OptionalCellValue from '@js/components/optional-cell-value';

const TableName = 'VUETABLE_TAX';

export default {
    components: {
        taxForm,
        CollectionCounter,
        OptionalCellValue,
    },

    data() {
        var that = this;
        let canManageTaxes = Auth.hasPermissionTo('franchise_manage_taxes');

        let actionButtons = [
            {
                title: 'Create Tax',
                action: () => {
                    this.showForm(null);
                },
            },
        ];

        if (!canManageTaxes) {
            actionButtons = [];
        }

        return {
            tax: null,
            tableName: TableName,
            api: Laroute.route('franchise.inventory.tax.index'),

            columns: [
                'name',
                'amount',
                'short_name',
                'mode',
                'inclusive',
                'products',
            ],

            options: {
                texts: {
                    title: 'Taxes',
                },
                checkbox: canManageTaxes,
                checkbox_actions: {
                    api_delete: Laroute.route('franchise.inventory.tax.delete'),
                    delete_title: 'Delete Taxes',
                },
                customFilters: ['outlet_id'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                },
                sortable: ['name', 'amount', 'short_name', 'inclusive', 'mode'],
                headings: {
                    short_name: 'Short Name',
                    inclusive: 'Amount Mode',
                    mode: 'Application Mode',
                },
                orderBy: { column: 'name', ascending: 1 },
                csv_url: Laroute.route('franchise.inventory.tax.exportAsFile', {
                    type: 'CSV',
                }),
                pdf_url: Laroute.route('franchise.inventory.tax.exportAsFile', {
                    type: 'PDF',
                }),
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => that.showForm(row.id),
                templates: {
                    products(h, row) {
                        return require('./products.jsx')(h, row);
                    },
                    amount(h, row) {
                        return require('./amount.jsx')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    mounted() {
        this.$refs.taxForm.$on('tax-saved', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        showForm(id) {
            this.$refs.taxForm.$emit('show-form', id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tax/vuetable_tax.vue